// IframeViewer.js
'use client';
import { connect } from 'react-redux';

import IframeViewer from '../page/IframeViewer.jsx';

import withRouter from '../component/WithRouter.jsx';
import {
  IFRAME_ALLOWED_URLS,
  IFRAME_BYPASS_PROXY_WHITELIST_DOMAINS,
  IFRAME_URL_PREFIX,
  IFRAME_STATIC_URL_PREFIX,
  IFRAME_POST_TOKEN_DOMAINS,
} from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import { push, replace } from '../action/navigationAction.js';
import toggleModal from '../action/toggleModal.js';

const mapStateToProps = state => {
  const meId = getMeData(state, 'id');

  const allowURL = getRemoteConfigData(state, IFRAME_ALLOWED_URLS);
  const bypassProxyURL = getRemoteConfigData(
    state,
    IFRAME_BYPASS_PROXY_WHITELIST_DOMAINS
  );

  return {
    meId,
    allowURL,
    bypassProxyURL,
    iframeUrlPrefix: getRemoteConfigData(state, IFRAME_URL_PREFIX),
    iframeStaticUrlPrefix: getRemoteConfigData(state, IFRAME_STATIC_URL_PREFIX),
    meToken: getMeData(state, 'token'),
    tokenWhitelistDomains: getRemoteConfigData(
      state,
      IFRAME_POST_TOKEN_DOMAINS
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: (...args) => dispatch(push(...args)),
    replace: (...args) => dispatch(replace(...args)),
    toggleModal: (...args) => dispatch(toggleModal(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IframeViewer)
);
